import { Typography } from '@mui/material';
import React from 'react';

interface HighlightMatchProps {
  text: string;
  query: string;
}

const HighlightMatch: React.FC<HighlightMatchProps> = ({ text, query }) => {
  const normalize = (text: string) => text.replace(/-/g, '').toLowerCase();

  const escapeRegExp = (string: string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  };

  if (!query) return <>{text}</>;

  const normalizedText = normalize(text);
  const normalizedQuery = normalize(escapeRegExp(query));

  const parts = [];
  let currentIndex = 0;

  const regex = new RegExp(`(${normalizedQuery})`, 'ig');
  let match;

  while ((match = regex.exec(normalizedText)) !== null) {
    const matchIndex = match.index;

    if (matchIndex > currentIndex) {
      parts.push(
        <Typography key={currentIndex} component="span">
          {text.slice(currentIndex, matchIndex)}
        </Typography>
      );
    }

    const matchedText = text.slice(matchIndex, matchIndex + normalizedQuery.length);
    parts.push(
      <Typography key={matchIndex} component="span" sx={{ fontWeight: 'bold', backgroundColor: 'yellow' }}>
        {matchedText}
      </Typography>
    );

    currentIndex = matchIndex + normalizedQuery.length;
  }

  if (currentIndex < text.length) {
    parts.push(
      <Typography key={currentIndex} component="span">
        {text.slice(currentIndex)}
      </Typography>
    );
  }

  return <>{parts}</>;
};

export default HighlightMatch;
